import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import Footer from "../Components/Footer";
import Navbar from "../Components/Header";
import profileIconWoman from "../Images/profileIcon.png";
import profileIconMan from "../Images/profileIconMan.png";

const TestimonialsWithBlobs = ({ children }) => {
  return (
    <section
      id="testimonies"
      className="relative py-20 bg-gradient-to-tr from-teal-50 via-teal-50 to-white overflow-hidden"
    >
      {/* Floating Blobs */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Blob 1 */} {/* Adjusted z-index */}
        {/* Blob 1 */}
        <div
          className=" absolute -left-1/4 -top-1/4 w-[200px] h-[200px]  md:w-[400px] md:h-[400px]  lg:w-[550px] lg:h-[550px] rounded-full bg-teal-400 animate-blob opacity-70"
          style={{
            borderRadius: "60% 40% 30% 70% / 30% 60% 40% 70%", // Irregular shape
          }}
        ></div>
        {/* Blob 2 */}
        <div
          className="absolute -right-1/4 -bottom-1/4 w-[300px] h-[300px]  md:w-[600px] md:h-[600px]  lg:w-[650px] lg:h-[650px] rounded-full bg-teal-400 animate-blob animation-delay-2000 opacity-70"
          style={{
            borderRadius: "60% 40% 30% 70% / 30% 60% 40% 70%", // Irregular shape
          }}
        ></div>
        {/* Blob 3 */}
        <div
          className="absolute left-1/3 top-1/3 w-[200px] h-[200px]  md:w-[400px] md:h-[400px]  lg:w-[350px] lg:h-[300px] rounded-full bg-teal-500 animate-blob animation-delay-4000 opacity-70"
          style={{
            borderRadius: "30% 40% 30% 70% / 30% 50% 40% 40%", // Irregular shape
          }}
        ></div>
        {/* Blob 4 */}
        <div
          className="absolute left-1/4 bottom-0 w-[300px] h-[200px]  md:w-[200px] md:h-[250px]  lg:w-[250px] lg:h-[250px] rounded-full bg-blue-300 animate-blob animation-delay-4000 opacity-70"
          style={{
            borderRadius: "60% 40% 30% 70% / 30% 60% 40% 70%", // Irregular shape
          }}
        ></div>
        {/* Blob 5 */}
        <div
          className="absolute right-1/5 bottom-1/4 w-[300px] h-[300px]  md:w-[400px] md:h-[400px]  lg:w-[350px] lg:h-[350px] rounded-full bg-blue-500 animate-blob animation-delay-2500 opacity-70"
          style={{
            borderRadius: "60% 40% 30% 30% / 30% 60% 40% 50%", // Irregular shape
          }}
        ></div>
        {/* Blob 6 */}
        <div
          className="absolute left-3/4 top-0 w-[300px] h-[300px]  md:w-[400px] md:h-[400px]  lg:w-[350px] lg:h-[350px] rounded-full bg-blue-400 animate-blob animation-delay-3500 opacity-70"
          style={{
            borderRadius: "60% 40% 30% 40% / 30% 60% 40% 20%", // Irregular shape
          }}
        ></div>
      </div>

      {/* Content */}
      <div className="relative">{children}</div>
    </section>
  );
};

const ReviewCard = ({ review, delay }) => {
  const { ref, inView } = useInView({
    triggerOnce: false, // Trigger the animation every time the element comes into view
    threshold: 0.1, // 10% of the card is in view
  });

  const getIconByGender = (gender) => {
    return gender === "female" ? profileIconWoman : profileIconMan;
  };

  return (
    <li
      ref={ref}
      className={`text-sm leading-6 transition-transform duration-500 ease-in-out transform  rounded-lg ${
        inView ? "scale-100 opacity-100" : "scale-75 opacity-50"
      }`}
      style={{ transitionDelay: `${delay}s` }}
    >
      <div className="relative    bg-gradient-to-br from-teal-100  to-teal-200 rounded-lg ">
        <div className="relative p-6 space-y-6 md:space-y-8 lg:space-y-10  bg-gradient-to-br from-blue-400 via-teal-500 to-teal-400  leading-none   border-teal-500 rounded-lg ">
          <div className="flex items-center">
            {Array(review.stars)
              .fill(0)
              .map((_, index) => (
                <svg
                  key={index}
                  xmlns="http://www.w3.org/2000/svg"
                  className="text-teal-100 "
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"></path>
                </svg>
              ))}
          </div>

          <div className="flex items-center space-x-4">
            <img
              src={getIconByGender(review.gender)}
              className="w-12 h-12 bg-center bg-cover border  text-teal-100 rounded-full"
              alt={review.name}
            />
            <div>
              <h3 className="text-lg font-semibold text-teal-100">
                {review.name}
              </h3>
              <p className="text-teal-100 text-md">{review.title}</p>
            </div>
          </div>
          <p className="leading-normal text-teal-100 text-md font-medium">
            {review.review}
          </p>
        </div>
      </div>
    </li>
  );
};

const Reviews = () => {
  const [reviews] = useState([
    {
      id: 1,
      name: "John D.",
      title: "Small Business Owner",
      review:
        "Solvexa Marketing helped us skyrocket our social media engagement. Amazing team!",

      stars: 5,
    },
    {
      id: 2,
      name: "Sarah M.",
      title: "Marketing Specialist",
      review:
        "Professional, creative, and result driven. They truly know digital marketing!",

      stars: 3,
      gender: "female",
    },
    {
      id: 3,
      name: "Michael T.",
      title: "E-commerce Manager",
      review:
        "Our brand visibility improved significantly thanks to Solvexa’s SEO strategies.",

      stars: 2,
      gender: "male",
    },
    {
      id: 4,
      name: "Emily R.",
      title: "Content Creator",
      review:
        "Incredible service! Their team brought fresh ideas to our branding.",

      stars: 4,
      gender: "female",
    },
    {
      id: 5,
      name: "David L.",
      title: "Media Producer",
      review: "The video content they produced for us exceeded expectations!",

      stars: 5,
      gender: "male",
    },
    {
      id: 6,
      name: "Sophia B.",
      title: "Social Media Coordinator",
      review:
        "Solvexa turned our social media around in no time. Highly recommended!",

      stars: 3,
      gender: "female",
    },
    {
      id: 7,
      name: "James K.",
      title: "Website Administrator",
      review:
        "Their web development team did a fantastic job with our site redesign.",

      stars: 4,
      gender: "male",
    },
    {
      id: 8,
      name: "Olivia P.",
      title: "Marketing Consultant",
      review:
        "Fast results and great communication. We love working with Solvexa Marketing!",

      stars: 5,
      gender: "female",
    },
    {
      id: 9,
      name: "Alexander W.",
      title: "Customer Relations Manager",
      review:
        "Their tailored marketing approach helped us connect better with our audience.",

      stars: 4,
      gender: "male",
    },
    {
      id: 10,
      name: "Lily G.",
      title: "Sales Manager",
      review:
        "We saw a noticeable increase in conversions after partnering with Solvexa.",

      stars: 3,
      gender: "female",
    },
    {
      id: 11,
      name: "M. Ali.",
      title: "Customer Relations Manager",
      review: "Beautiful ui creation for my school website",

      stars: 5,
      gender: "male",
    },
    {
      id: 12,
      name: "Fatima B.",
      title: "Sales Manager",
      review: "Good Experience in web development",

      stars: 4,
      gender: "female",
    },
  ]);

  // Split reviews into three nearly equal columns
  const columnSize = Math.ceil(reviews.length / 3);
  const columns = [
    reviews.slice(0, columnSize),
    reviews.slice(columnSize, columnSize * 2),
    reviews.slice(columnSize * 2),
  ];

  return (
    <>
      <div className="">
        <Navbar color={"bg-white text-teal-950"} />
      </div>
      <TestimonialsWithBlobs>
        <div className="max-w-6xl mx-8 md:mx-10 lg:mx-20 xl:mx-auto">
          <div className="transition duration-500 ease-in-out transform scale-100 translate-x-0 translate-y-0 opacity-100">
            <div className="mb-12 space-y-5 md:mb-16 md:text-center">
              <div className="inline-block px-3 py-1 text-sm font-semibold text-teal-900 rounded-lg md:text-center text-cn bg-slate-400 bg-opacity-30 hover:cursor-pointer hover:bg-opacity-40">
                Words from Others
              </div>
              <h1 className="mb-5 text-3xl font-semibold text-teal-500 md:text-center md:text-5xl">
                It's not just us.
              </h1>
              <p className="text-md text-gray-600 md:text-center md:text-xl">
                Here's what our customers have to say about us.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
            {columns.map((column, index) => (
              <ul key={index} className="space-y-8">
                {column.map((review, idx) => (
                  <ReviewCard
                    key={review.id}
                    review={review}
                    delay={idx * 0.2}
                  />
                ))}
              </ul>
            ))}
          </div>
        </div>
      </TestimonialsWithBlobs>
      <Footer />
    </>
  );
};

export default Reviews;
